import { CenterModal } from '@dehaat/dds';
import { DEFAULT_LANG } from '@dehaat/kisan-app-bl/constants/common';
import { FULFILLMENT_TYPE } from '@dehaat/kisan-app-bl/models/Vendor';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { PropsWithChildren, useContext, useEffect, useState } from 'react';
import styles from 'src/styles/HideScrollbar.module.css';
import { ASSISTED_USER_ID, ASSISTED_USER_NAME, ASSISTED_USER_NUMBER, AVAILABLE_STOCK, NAVIGATION_FROM_APP_CODE, NAVIGATION_FROM_IS_ASSISTED_ORDERING } from '@/constants/common';
import { CartContext } from '@/context/CartProvider';
import { UserContext } from '@/context/UserProvider';
import { useAppSelector } from '@/hooks/reduxHooks';
import useIsMobile from '@/hooks/useIsMobile';
import useTriggerEvents from '@/hooks/useTriggerEvents';
import { Coupon, ProductVariant } from '@/models/Product';
import { selectCurrentVendor } from '@/store/features/locationSlice';
import { conversionLabels } from '@/utils/analytics/conversionLabels';
import CustomEventTypes from '@/utils/analytics/customEventTypes';
import {
// trackCustomEvent,
trackGAConversionEvent } from '@/utils/analytics/googleAnalytics';
import { ProductListTypeEnum } from '@/utils/analytics/types';
import addNotifyMe from '@/utils/api/addNotifyMe';
import { productCatalogueId } from '@/utils/cart';
import { getCookieValue, isArray, isFromVrApp, isSessionStorageAvailable } from '@/utils/helper';
import { getCartUpdatePricing, getVariantPricing } from '@/utils/helpers/flashSale';
import formatCurrency from '@/utils/helpers/formatCurrency';
import OfferCard from '../growth/OfferCard';
import EditIcon2 from '../icons/EditIcon2';
import ArrowRight from '../icons/growth/ArrowRight';
import MinusIcon from '../icons/MinusIcon';
import NotifyMeIcon from '../icons/NotifyMeIcon';
import PlusIcon from '../icons/PlusIcon';
import { Toast } from '../Toast';
import FlashSalePrice from './flashSale/FlashSalePrice';
interface PackageTypeButtonProps {
  isSelected: boolean;
  onClick: () => void;
}
export const requiredPathName = (asPath: string) => {
  const isVR = isFromVrApp(getCookieValue(NAVIGATION_FROM_APP_CODE));
  if (isVR) {
    if (asPath.includes('/s?') || asPath.includes('/s')) return 'Search';
  }
  if (asPath.includes('s=') || asPath.includes('so=y')) return 'Search';else if (asPath.includes('product/')) return 'Product Detail Page';else if (asPath.includes('wishlist')) return 'Wishlist';else if (asPath.includes('products')) return 'Product Listing Page';else if (asPath.includes('cart')) return 'Cart';else if (asPath === '/' || asPath.includes('tab=')) return 'Home';
};
const PackageTypeButton = ({
  children,
  isSelected,
  onClick
}: PropsWithChildren<PackageTypeButtonProps>) => <div className={`justify-center px-4 py-1.5 rounded-lg border cursor-pointer min-w-fit ${isSelected ? 'bg-green-100 border-green-700' : 'bg-white border-slate-300'}`} onClick={onClick} data-sentry-component="PackageTypeButton" data-sentry-source-file="AddToCart2.tsx">
    {children}
  </div>;
interface Props {
  productName: string;
  productId?: string;
  productVariants: ProductVariant[];
  offer: Coupon | undefined;
  onEditClick: (variant: ProductVariant, index: number) => void;
  latLng: string | null;
  isNotify?: boolean;
  productBrand?: string;
  productCategory?: string;
  selectedVariantIndex?: number;
  isOutOfStock?: boolean;
}
const AddToCart2 = ({
  productName,
  productId,
  productVariants,
  offer,
  onEditClick,
  isNotify,
  productBrand,
  productCategory,
  selectedVariantIndex,
  isOutOfStock
}: Props) => {
  const {
    t
  } = useTranslation('products');
  const [selectedVarient, setSelectedVarient] = useState<ProductVariant>();
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const {
    query,
    push,
    locale
  } = useRouter();
  const {
    cartItems,
    updateCart,
    currentVendor
  } = useContext(CartContext);
  const {
    user
  } = useContext(UserContext);
  const {
    isMobile
  } = useIsMobile();
  const vendorDetails = useAppSelector(selectCurrentVendor);
  const router = useRouter();
  const {
    trackCustomEvent
  } = useTriggerEvents();
  const [isNotifyCentralModalVisible, setIsNotifyCentralModalVisible] = useState(false);
  const [notify, setNotify] = useState(isNotify);
  const [notifyModalMessageKey, setNotifyModalMessageKey] = useState<'success' | 'already_requested' | null>(null);
  const [isToast, setIsToast] = useState(false);
  const quantity = selectedVarient ? cartItems[selectedVarient.id] || 0 : 0;
  const pricing = selectedVarient ? getVariantPricing(selectedVarient) : null;
  const discount = pricing?.discount ?? 0;
  const price = pricing?.mrp ?? 0;
  const discountPercent = pricing?.discountPercent ?? 0;
  const isFlashSale = pricing?.isFlashSale ?? false;
  const StockInSS = typeof window !== 'undefined' && isSessionStorageAvailable(window) && sessionStorage?.getItem(AVAILABLE_STOCK);
  const availableStock = StockInSS ? JSON.parse(StockInSS) : undefined;
  const diasbleAdd = availableStock && selectedVarient && availableStock[selectedVarient.id] !== 'undefined' && quantity >= availableStock[selectedVarient.id];
  const productInStock = selectedVarient ? isArray(selectedVarient?.inventory_set) : false;
  const isAssumeUser = [getCookieValue(ASSISTED_USER_ID), getCookieValue(ASSISTED_USER_NAME), getCookieValue(ASSISTED_USER_NUMBER)].every(Boolean);

  // Add this effect to handle selectedVarient changes
  useEffect(() => {
    if (productVariants.length > 0) {
      if (query.productVariantId) {
        setSelectedVarient(productVariants.find(item => item.id === query.productVariantId));
      } else {
        setSelectedVarient(productVariants[0]);
      } // Set to the first variant if available
    }
  }, [productVariants, query.productVariantId]);
  useEffect(() => {
    if (typeof selectedVariantIndex === 'number' && productVariants[selectedVariantIndex]) {
      setSelectedVarient(productVariants[selectedVariantIndex]);
    }
  }, [selectedVariantIndex, productVariants]);
  const onAddOrRemoveFromCart = (isAdd: boolean) => {
    if (selectedVarient) {
      const pricing = getCartUpdatePricing(selectedVarient);
      updateCart({
        variantId: selectedVarient.id,
        quantity: 1,
        index: productVariants.findIndex(variant => variant.id == selectedVarient.id),
        type: ProductListTypeEnum.PRODUCT_DETAIL,
        ...pricing,
        name: selectedVarient.product?.name,
        brandName: selectedVarient.product?.brand?.name,
        catalogueId: productCatalogueId(selectedVarient.inventory_set),
        groupId: {
          parent_id: selectedVarient.product?.parent_id,
          parent_type: selectedVarient.product?.parent_type
        }
      }, isAdd);
    }
  };
  const notifyEventProps = {
    VendorName: vendorDetails?.company_name,
    VendorId: vendorDetails?.id,
    ProductName: productName,
    ProductBrand: productBrand,
    ProductCategory: productCategory,
    PageLocation: router.asPath,
    PageName: requiredPathName(router.asPath)
  };
  const addToCart = async () => {
    if (!productInStock) {
      trackCustomEvent(CustomEventTypes.ADD_TO_CART_INTENT, JSON.stringify({
        Product: productName,
        Source: 'PDP',
        VendorName: vendorDetails?.company_name,
        VendorId: vendorDetails?.id,
        Product_Id: productId
      }));
      try {
        const result = await addNotifyMe({
          productId: Number(productId),
          locale: locale || DEFAULT_LANG,
          triggerSource: 'NOTIFYME'
        });
        if (result?.success) {
          const alreadyRequested = result?.success && Boolean(result?.message?.toLowerCase().includes('already'));
          if (result?.success && !alreadyRequested) {
            setNotify(true);
            trackCustomEvent(CustomEventTypes.USER_CLICKED_NOTIFY_ME_CTA, JSON.stringify(notifyEventProps));
          }
          setNotifyModalMessageKey(alreadyRequested ? 'already_requested' : 'success');
          setIsNotifyCentralModalVisible(true);
        } else if (!result.success && result.message.includes('Unauthorized')) {
          setIsToast(true);
        }
      } catch (err) {
        console.error('Failed to add notify me:', err);
      }
      return null;
    }
    onAddOrRemoveFromCart(true);
    const eventParam = {
      ProductName: productName,
      ProductVariant: selectedVarient?.id,
      ProductBrand: productBrand,
      ProductCategory: productCategory,
      ProductPrice: price,
      Page: router.asPath,
      VendorName: vendorDetails?.company_name,
      VendorId: vendorDetails?.id,
      Attribute: selectedVarient?.attribute_value[0].name
    };
    quantity ? trackCustomEvent(CustomEventTypes.ADD_ONE_ITEM_TO_CART) : trackCustomEvent(CustomEventTypes.ADD_TO_CART, JSON.stringify(eventParam));
    trackGAConversionEvent(CustomEventTypes.ADD_TO_CART, {}, conversionLabels.ADD_TO_CART);
  };
  const removeFromCart = () => {
    onAddOrRemoveFromCart(false);
    trackCustomEvent(CustomEventTypes.REMOVE_ONE_ITEM_FROM_CART);
  };
  useEffect(() => {
    if (query && query.from && query.from === 'posts') {
      addToCart();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (query && query.addToCart && query.addToCart === 'true') {
      if (selectedVarient) {
        if (!cartItems[selectedVarient.id]) {
          addToCart();
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);
  useEffect(() => {
    let qty = 0;
    let tPrice = 0;
    productVariants.forEach(variant => {
      const id = variant.id.toString();
      if (cartItems[id]) {
        const quantity = cartItems[id];
        qty += quantity;
        const {
          salePrice
        } = getVariantPricing(variant);
        tPrice += Math.floor(salePrice) * quantity;
      }
    });
    setTotalQuantity(qty);
    setTotalPrice(tPrice);
  }, [cartItems, productVariants]);
  const showEditPrice = currentVendor?.fulfillment_type === FULFILLMENT_TYPE.PICKUP_FROM_STORE && user?.is_variant_price_editable;
  const orderingFor = getCookieValue(NAVIGATION_FROM_IS_ASSISTED_ORDERING) === 'true';
  return <div data-sentry-component="AddToCart2" data-sentry-source-file="AddToCart2.tsx">
      <div className={isMobile ? 'fixed bottom-0 left-0 right-0 z-[48]' : ''} style={{
      background: `#fff`
    }}>
        <div className="flex flex-col justify-center leading-[143%]">
          <div className={`flex flex-col px-4 gap-2 py-3 ${isMobile ? 'w-full bg-slate-50 shadow-black shadow-2xl rounded-t-xl' : ''}`}>
            {productVariants?.length > 0 && <>
                <div className="flex gap-1 item-center">
                  <p className="font-normal text-[#5A6066] text-xs tracking-tight">
                    {t('select_varient_type')}
                  </p>
                </div>
                <div className={`flex gap-2 text-base tracking-tight text-neutral-700 overflow-x-scroll ${!isMobile ? 'flex-wrap' : ''} ${styles.scroll}`}>
                  {productVariants.map((variant, index) => <PackageTypeButton key={index} isSelected={selectedVarient?.id === variant.id} onClick={() => {
                trackCustomEvent(CustomEventTypes.VARIANT_SELECTION, JSON.stringify({
                  Product: productName,
                  Variant: variant.id,
                  Price: price - discount,
                  Source: 'PDP'
                }));
                setSelectedVarient(variant);
              }}>
                      {variant.attribute_value[0].name}
                    </PackageTypeButton>)}
                </div>
              </>}
            {!isMobile && offer && Object.keys(offer).length > 0 && <OfferCard offer={offer} containerClass="bg-purple-50 p-4" />}
            <div className={`flex justify-between py-2.5 ${isMobile ? 'bg-white rounded px-4' : ' flex-col'} ${isMobile && discount ? 'gap-1' : 'gap-4'}  `}>
              <div className={`flex flex-wrap gap-x-3 ${isMobile ? 'flex-col justify-center' : 'flex-row items-center'}`}>
                {!productInStock ? <strong>
                    <span className="align-middle">{t('out_of_stock')}</span>
                  </strong> : <>
                    <div className="flex items-center whitespace-nowrap">
                      {isFlashSale && selectedVarient ? <FlashSalePrice variant={selectedVarient} /> : discount ? <>
                          <span className="font-bold text-zinc-900 text-2xl tracking-tight">
                            {formatCurrency(price - discount)}
                          </span>
                          <span className="my-auto ml-1 font-medium text-gray-500 text-sm line-through text-ellipsis">
                            {formatCurrency(price)}
                          </span>
                          <span className="ml-1 text-[#43A314] text-xs">
                            ({discountPercent}% {t('sale_off')})
                          </span>
                        </> : <p className="font-bold text-zinc-900 text-2xl tracking-tight">
                          {formatCurrency(price)}
                        </p>}
                    </div>

                    {showEditPrice && selectedVarient && <button className="flex items-center text-primary-100 cursor-pointer" onClick={() => {
                  const index = productVariants.findIndex(variant => variant.id == selectedVarient.id);
                  onEditClick(selectedVarient, index);
                }}>
                        <EditIcon2 className="fill-white stroke-primary-100 mr-1 w-3 h-3" />
                        {t('edit_price')}
                      </button>}
                  </>}
              </div>

              {quantity === 0 ? <button className={`flex justify-center items-center px-4 py-2 rounded-md w-28 min-w-28 font-semibold text-white ${notify ? 'bg-[#F5F8FA] border border-[#E6EBF0] text-primary-100' : 'bg-[#0E7A41]'}`} onClick={() => {
              if (!isOutOfStock) addToCart();
            }}>
                  <strong>
                    <span className="align-middle">
                      {isOutOfStock ? t('out_of_stock') : notify ? <NotifyMeIcon width={27} height={27} /> : productInStock ? t('add') : t('notify_me')}
                    </span>
                  </strong>
                </button> : <div className="flex justify-center items-center bg-primary-10 px-4 py-2 border border-primary-80 rounded-md w-32 font-semibold text-white">
                  <button onClick={removeFromCart}>
                    <MinusIcon width={20} height={20} className="stroke-primary-110" />
                  </button>

                  <span className="flex-grow m-auto h-fit text-primary-100 text-lg text-center">
                    {quantity}
                  </span>

                  <button disabled={diasbleAdd} onClick={addToCart}>
                    <PlusIcon width={20} height={20} className={diasbleAdd ? 'stroke-neutral-30' : 'stroke-primary-100'} />
                  </button>
                </div>}
            </div>
            {isMobile && totalQuantity > 0 && <div className="flex justify-between items-center bg-[#0E7A41] p-3 rounded-md w-full text-white">
                <p>
                  {totalQuantity} {t('common:item')} . ₹{totalPrice}
                </p>
                <div>
                  <button className="flex items-center gap" onClick={() => {
                push({
                  pathname: orderingFor && !isAssumeUser ? '/select-farmer' : '/cart'
                });
              }}>
                    {t('buy_now')} <ArrowRight color="#fff" />
                  </button>
                </div>
              </div>}
          </div>
        </div>
      </div>
      {isToast && <Toast message={t('login_to_add_notification')} onClose={() => setIsToast(false)} />}
      <CenterModal isVisible={isNotifyCentralModalVisible} onClose={() => {
      setIsNotifyCentralModalVisible(false);
      setNotifyModalMessageKey(null);
    }} data-sentry-element="CenterModal" data-sentry-source-file="AddToCart2.tsx">
        <NotifyMeIcon width={64} height={64} bell="#FFAC33" tick="#0F8040" data-sentry-element="NotifyMeIcon" data-sentry-source-file="AddToCart2.tsx" />
        <div className="flex flex-col gap-1 py-4 text-center">
          <h1 className="font-semibold text-[#33393D] text-base">
            {t(notifyModalMessageKey === 'already_requested' ? 'already_requested' : 'success')}
            !
          </h1>
          {notifyModalMessageKey === 'already_requested' ? <p className="font-normal text-[#5A6066] text-sm">
              {t('notify_me_requested')}
            </p> : null}

          {notifyModalMessageKey && <p className="font-normal text-[#5A6066] text-sm">
              {t('notify_me_available')}
            </p>}
        </div>
      </CenterModal>
    </div>;
};
export default AddToCart2;